import { render, staticRenderFns } from "./FormTeam.vue?vue&type=template&id=03c20bf8&"
import script from "./FormTeam.vue?vue&type=script&lang=js&"
export * from "./FormTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports